import React, { useState, useEffect } from 'react';

function LapMastergaji() {
  const [LapPasangData, setLapPasangData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [listTransaksi, setListTransaksi] = useState([]);
  const [no_transaksi, setNoTransaksi] = useState('');
  const [filters, setFilters] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [listAsal, setListAsal] = useState([]);
  const [asal, setAsal] = useState('');
  const [listTujuan, setListTujuan] = useState([]);
  const [tujuan, setTujuan] = useState('');
  const schema = localStorage.getItem('schema');

  const numericKeys = [
    'TOTAL',
    'MIN_KG',
    'MAX_KG',
    'LITER',
    'HARI_ONTIME',
  ];

  const columns = [
    'WILAYAH_ASAL',
    'WILAYAH_TUJUAN',
    'SUBCITY',
    'JNS_GAJI',
    'TOTAL',
    'MIN_KG',
    'MAX_KG',
    'LITER',
    'NAMAREKANAN',
    'JNS_MUATAN',
    'HARI_ONTIME',
  ];

const columnLabels = {
  WILAYAH_ASAL: 'Asal',
  WILAYAH_TUJUAN: 'Tujuan',
  SUBCITY: 'Sub Kota',
  JNS_GAJI: 'Jenis Gaji',
  TOTAL: 'Total',
  MIN_KG: 'Min Berat',
  MAX_KG: 'Max Berat',
  LITER: 'Liter',
  NAMAREKANAN: 'Customer',
  JNS_MUATAN: 'Jns Muatan',
  HARI_ONTIME: 'Hari Ontime',
};


  const formatNumber = (value) =>
    isNaN(value) ? value : new Intl.NumberFormat('id-ID').format(Number(value));

  const fetchPilihanTransaksi = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/lap_mg.php?caller=pilih_mg&schema=${schema}`);
      const data = await res.json();
      if (Array.isArray(data)) {
        setListTransaksi(data);
        if (data.length > 0) {
          setNoTransaksi(data[0].NO_TRANSAKSI);  
        }
      }
    } catch (error) {
      alert('Gagal memuat pilihan transaksi');
    }
  };

const fetchPilihanAsal = async () => {
  if (!no_transaksi) return;
  try {
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/lap_mg.php?caller=pilih_asal&schema=${schema}&no_transaksi=${no_transaksi}`);
    const data = await res.json();
    if (Array.isArray(data)) {
      setListAsal(data);
      if (data.length > 0) {
        setAsal(data[0].WILAYAH_ASAL);
      }
    }
  } catch (error) {
    alert('Gagal memuat pilihan asal');
  }
};


const fetchPilihanTujuan = async () => {
  if (!no_transaksi) return;
  if (!asal) return;
  try {
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/lap_mg.php?caller=pilih_tujuan&schema=${schema}&no_transaksi=${no_transaksi}&asal=${asal}`);
    const data = await res.json();
    if (Array.isArray(data)) {
      setListTujuan(data);
      if (data.length > 0) {
        setTujuan(data[0].WILAYAH_TUJUAN);
      }
    }
  } catch (error) {
    alert('Gagal memuat pilihan asal');
  }
};

  const fetchLapPasangData = async () => {
    if (!no_transaksi) return;
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/lap_mg.php?caller=isi_mg2&schema=${schema}&no_transaksi=${no_transaksi}&asal=${asal}&tujuan=${tujuan}`;
      const response = await fetch(url);
      const data = await response.json();
      if (Array.isArray(data)) {
        setLapPasangData(data);
        setFilteredData(data);
      } else {
        throw new Error('Data tidak valid');
      }
    } catch (error) {
      alert('Gagal memuat data');
    }
  };

  useEffect(() => {
    fetchPilihanTransaksi();
  }, []);

  useEffect(() => {
    fetchPilihanAsal();
  }, [no_transaksi]);

  useEffect(() => {
    if (asal) {
      fetchPilihanTujuan();
    }
  }, [asal]);


  useEffect(() => {
    let filtered = LapPasangData.filter((item) =>
      Object.keys(filters).every((key) =>
        filters[key] === '' || String(item[key] ?? '').toLowerCase().includes(filters[key].toLowerCase())
      )
    );
    setFilteredData(filtered);
  }, [filters, LapPasangData]);

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction });

    const sorted = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredData(sorted);
  };

  const getSortIcon = (key) =>
    sortConfig.key === key ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '';

  return (
    <div style={{ padding: '20px', backgroundColor: '#fff' }}>
      <h2 style={{ color: '#9B459C' }}>Master Gaji</h2>
      <div style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '8px', maxWidth: '300px' }}>
        <select
          value={no_transaksi}
          onChange={(e) => setNoTransaksi(e.target.value)}
          style={{ marginLeft: '10px', padding: '5px' }}
        >
          {listTransaksi.map((item, idx) => (
            <option key={idx} value={item.NO_TRANSAKSI}>
              {item.JNS_KENDARAAN} ( {item.TGL_TRANSAKSI} - {item.NO_TRANSAKSI} )
            </option>
          ))}
        </select>

        <select
          value={asal}
          onChange={(e) => setAsal(e.target.value)}
          style={{ marginLeft: '10px', padding: '5px' }}
        >
          {listAsal.map((item, idx) => (
            <option key={idx} value={item.WILAYAH_ASAL}>
              {item.WILAYAH_ASAL}
            </option>
          ))}
        </select>

        <select
          value={tujuan}
          onChange={(e) => setTujuan(e.target.value)}
          style={{ marginLeft: '10px', padding: '5px' }}
        >
          {listTujuan.map((item, idx) => (
            <option key={idx} value={item.WILAYAH_TUJUAN}>
              {item.WILAYAH_TUJUAN}
            </option>
          ))}
        </select>


        <button onClick={fetchLapPasangData} style={{ marginLeft: '10px', padding: '5px 10px' }}>
          Refresh
        </button>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th
                  key={col}
                  onClick={() => handleSort(col)}
                  style={{
                    border: '1px solid #ccc',
                    padding: '8px',
                    backgroundColor: '#f2f2f2',
                    textAlign: 'center',
                    cursor: 'pointer',
                  }}
                >
                   {columnLabels[col] || col} {getSortIcon(col)}
                </th>
              ))}
            </tr>
            <tr>
              {columns.map((col) => (
                <th key={`filter-${col}`} style={{ border: '1px solid #ccc', padding: '4px' }}>
                  <input
                    type="text"
                    placeholder="Filter..."
                    style={{
                      width: '90%',
                      padding: '4px',
                      borderRadius: '4px',
                      border: '1px solid #ddd',
                    }}
                    onChange={(e) => setFilters({ ...filters, [col]: e.target.value })}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, idx) => (
                <tr key={idx}>
                  {columns.map((key) => (
                    <td
                      key={key}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        textAlign: numericKeys.includes(key) ? 'right' : 'left',
                      }}
                    >
                      {numericKeys.includes(key) ? formatNumber(item[key]) : item[key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: 'center', padding: '10px' }}>
                  Tidak ada data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LapMastergaji;
